<template>
  <div id="app" class="container">
    <header>
    <div class="buttons">
      <a class="left mobile" href="#" v-on:click="openLeft"><img class="burger" src="/img/svg/menu.svg"></a>
    </div>
    </header>
    <nav v-bind:class="['bgcolor',{ 'nav-hidden' : navOpen }]">
      <a class="left mobile" href="#" v-on:click="openLeft"><img class="closebutton" src="/img/svg/x.svg"></a>
      <transition name="slide-fade">
        <router-view name="nav"/>
      </transition>
    </nav>
    <main>
      <transition name="slide-fade">
        <router-view name="main"/>
      </transition>
    </main>
    <aside name="side">
      <side></side>
    </aside>
    <footer name="footer">
      <untermenu></untermenu>
    </footer>
  </div>
</template>

<script>
import side from '@/components/Includes/side.vue'
import untermenu from '@/components/Includes/untermenu.vue'
export default {
  name: 'App',
  data: function () {
    return {
      navOpen: true
    }
  },
  methods: {
    openLeft: function () {
      this.navOpen = !this.navOpen
    }
  },
  components: {
    side,
    untermenu
  }
}
</script>

<style>

body{
  transition: 0.8s;
  overflow:hidden;
}

.slide-fade-enter-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
  .container {
    display: grid;

    grid-template-areas:
      "header"
      "content"
      "side"
      "footer";

    grid-template-columns: 1fr;
    grid-template-rows:
      auto                /* Header */
      1fr                 /* Content */
      minmax(75px, auto)  /* Sidebar */
      auto;               /* Footer */
    grid-gap: 0px;
    height:100vh;
}

header {
  grid-area: header;
  height:90px;
}

.buttons img, .closebutton{
  width:40px;
  padding-left:10px;
  padding-top:10px;
  margin-left:20px;
  margin-top:16px;
  z-index: 10;
}

.buttons{
  width:100%;
}

nav{
    transition: 0.8s;
    top: 0;
    bottom: 0;
    position: fixed;
    width: auto;
    left: 0px;
    z-index: 10;
}

.nav-hidden{
  left: -200px;
}

main {
  grid-area: content;
  overflow:hidden;
}

aside {
  grid-area: side;
}

footer {
  grid-area: footer;
  display:none;
}

@media (min-width: 980px) {
  .container {
    grid-template-areas:
      "header header header"
      "nav content side"
      "footer footer footer";

    grid-template-columns: 150px 1fr 120px;
    grid-template-rows: auto 1fr auto;
    grid-gap: 10px;
    width:100vw;
    height: 100vh;
  }
  header {
    height:0px;
    z-index: 11;
  }

  footer{
    display:block;
    margin-top:-110px;
  }

  .mobile{
    display:none;
  }
  .nav-hidden{
    left: 0px;
    display:block;
  }
  nav{
    width:200px;
  }
}

@media (orientation: landscape) and (max-width:981px){

.closebutton{
  display:none;
}

body{
  overflow:hidden;
}
header{
  display: none;
}
footer{
  display:none;
}

.nav-hidden{
  left: 0px;
  display:block;
}
nav{
  width:120px;
}

.container {
grid-template-areas:
  "nav content side"
  "nav content side"
  "nav content side";

  grid-template-columns: 150px 1fr 125px;
  grid-template-rows: auto 1fr auto;
  grid-gap: 10px;
  width:100vw;
  height: 100vh;
}

.swiper-container{
  overflow:visible !important;
}

}



@media (orientation: landscape) and (max-height: 414px) {
  .container {
    grid-template-columns: 120px 1fr 137px;
  }
}

@media (orientation: landscape) and (max-height: 411px) {
  .container {
    grid-template-columns: 120px 1fr 137px;
  }
}

@media (orientation: landscape) and (max-height: 375px) {
  .container {
    grid-template-columns: 120px 1fr 125px;
  }
}

@media (orientation: landscape) and (max-height: 360px) {
  .container {
    grid-template-columns: 120px 1fr 120px;
  }
}

@media (orientation: landscape) and (max-height: 320px) {
  .container {
    grid-template-columns: 120px 1fr 106px;
  }
}
</style>
